// Arabic-Indic numeral formatter
const DIGITS = '٠١٢٣٤٥٦٧٨٩';

/** Convert any number / string containing Western digits → Arabic-Indic */
export const arNum = (n) => String(n).replace(/[0-9]/g, d => DIGITS[d]);

/** Format a price with Arabic-Indic digits and thousands separator */
export const arPrice = (n) =>
  arNum(parseFloat(n || 0).toLocaleString('en-US'));

/** Format a date string as short Arabic date */
export const arDate = (d) =>
  d ? new Date(d).toLocaleDateString('ar-SA', { year: 'numeric', month: 'short', day: 'numeric' }) : '—';

/** Format a datetime string as HH:MM (Arabic digits) */
export const arTime = (dt) => {
  if (!dt) return '—';
  if (/^\d{2}:\d{2}/.test(dt)) return arNum(dt.slice(0, 5));
  const m = String(dt).match(/T(\d{2}:\d{2})/);
  return m ? arNum(m[1]) : arNum(dt);
};
